import { render } from "./DocumentsHome.vue?vue&type=template&id=04d4fce6&scoped=true"
import script from "./DocumentsHome.vue?vue&type=script&lang=js"
export * from "./DocumentsHome.vue?vue&type=script&lang=js"

import "./DocumentsHome.vue?vue&type=style&index=0&id=04d4fce6&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d4fce6"]])

export default __exports__